import { ImageUpload } from '#assets/svg';
import { useDashboardCharFormExerciseState } from '#pages/DashboardChartForm/states/dashboardCharFormExerciseState';
import { produce } from 'immer';
import { useEffect, useState } from 'react';
import { FileUpload } from 'src/shared/components/file-upload/FileUpload';
import { P, match } from 'ts-pattern';
import { useDraftChartForEdit } from '../useDraftChartForEdit';

export const DraftEachExerciseMedia = () => {
  const { records, setRecords } = useDashboardCharFormExerciseState();

  const { draftChart } = useDraftChartForEdit();

  const [draftFileInfoList, setDraftFileInfoList] = useState<
    { id: string; url: string; type: 'videos' | 'images' }[][]
  >([]);

  useEffect(() => {
    if (draftChart?.records && draftChart?.records.length > 0) {
      draftChart.records.forEach(record => {
        if (record.videos && record.videos.length > 0) {
          setDraftFileInfoList(
            produce(draft => {
              draft.push(
                record.videos!.map(video => ({
                  id: video.id,
                  url: video.resizedLink,
                  type: 'videos'
                }))
              );
            })
          );
        }

        if (record.images && record.images.length > 0) {
          setDraftFileInfoList(
            produce(draft => {
              draft.push(
                record.images!.map(image => ({
                  id: image.id,
                  url: image.resizedLink,
                  type: 'images'
                }))
              );
            })
          );
        }
      });
    }
  }, [draftChart]);

  const onUploadFileComplete = (
    id: string,
    type: 'videos' | 'images',
    index: number
  ) => {
    match(records[index][type])
      .with(undefined, () => {
        setRecords(
          produce(draft => {
            draft[index][type] = [id];
          })
        );
      })
      .with(P.array(P.string), () => {
        setRecords(
          produce(draft => {
            draft[index][type]?.push(id);
          })
        );
      })
      .exhaustive();
  };

  const onRemoveFileComplete = (
    id: string,
    type: 'videos' | 'images',
    index: number
  ) => {
    if (!records[index]) return;

    setRecords(
      produce(draft => {
        draft[index][type] = draft[index][type]?.filter(file => file !== id);
      })
    );
  };

  return (
    <div className="flex flex-col gap-20 mt-16">
      {records.map((record, index) => {
        return (
          <div>
            <div className="flex gap-8">
              <div
                style={{
                  display: 'flex',
                  width: '20px',
                  height: '20px',
                  padding: '4px 0',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '10px',
                  borderRadius: '4px',
                  background: 'var(--bg-500, #373245)'
                }}
              >
                <div
                  style={{
                    color: 'var(--Gray-Scale-500, #948F9E)',
                    textAlign: 'center',
                    fontFamily: '"Pretendard Variable"',
                    fontSize: '12px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    lineHeight: '16px'
                  }}
                >
                  {index + 1}
                </div>
              </div>
              <div className="text-[#d7d2de] text-base font-normal font-['Pretendard Variable'] leading-[21px]">
                {record.exerciseKind || '운동 이름'}
              </div>
            </div>
            <FileUpload
              maxCountMsg={''}
              path={'exercise-image'}
              fileType={'.jpg,.jpeg,.png,.mp4,.mov,.svg'}
              // onChange={onChange}
              maxCount={5}
              onUploadFileComplete={(id, type) =>
                onUploadFileComplete(id, type, index)
              }
              onDeleteFileComplete={(id, type) =>
                onRemoveFileComplete(id, type, index)
              }
              defaultFileInfoList={draftFileInfoList[index]}
            >
              <ImageUpload />
            </FileUpload>
          </div>
        );
      })}
    </div>
  );
};
